/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim2DiagMaxRightIcon16Regular = forwardRef('ArrowDim2DiagMaxRightIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.5 1.25a.75.75 0 0 0 0 1.5h2.69L8.72 6.22a.75.75 0 0 0 1.06 1.06l3.47-3.47V6.5a.75.75 0 0 0 1.5 0v-4c0-.69-.56-1.25-1.25-1.25h-4Z" }),
        React.createElement("path", { d: "M7.28 9.78a.75.75 0 0 0-1.06-1.06l-3.47 3.47V9.5a.75.75 0 0 0-1.5 0v4c0 .69.56 1.25 1.25 1.25h4a.75.75 0 0 0 0-1.5H3.81l3.47-3.47Z" })));
});
